import React from 'react';
import {
  ClockCircleOutlined,
  CheckCircleOutlined,
  WarningOutlined,
  PauseCircleOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons';

const devStatusConfig = {
  backlog: {
    icon: <ClockCircleOutlined style={{ color: '#8C8C8C' }} />,
  },
  // eslint-disable-next-line camelcase
  on_track: {
    icon: <CheckCircleOutlined style={{ color: '#4B9FFF' }} />,
  },
  // eslint-disable-next-line camelcase
  at_risk: {
    icon: <WarningOutlined style={{ color: '#FFA500' }} />,
  },
  delayed: {
    icon: <PauseCircleOutlined style={{ color: '#E5493A' }} />,
  },
  done: {
    icon: <CheckSquareOutlined style={{ color: '#6ABF4B' }} />,
  },
};

export default devStatusConfig;
